import React       from 'react';
import CustomQuote from 'pu-react/components/CustomQuote';

const Component = props => (
  <div className="px-3 pb-3 custom-quote">
    <CustomQuote
      {...props}
      buttonTop={false}
      buttonBottom buttonClassName="btn btn-primary"
      title="Do you need a Custom Quote?">
      <div className="col-md-12">
        <ul className="list-no-padding">
          <li>Ctrl Impedance</li>
          <li>Via Fill</li>
          <li>Blind / Buried Vias</li>
          <li>Heavy Copper Weight</li>
          <li>Ctrl Dielectric</li>
          <li>Castellated Holes</li>
        </ul>
      </div>
    </CustomQuote>
  </div>
);

export default Component;
